import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useEffect, useRef } from 'react';
import { RateAppointment } from 'components/RateAppointment';
import { useFetchNextAppointments } from 'hooks/useFetchNextAppointments';
import { AppointmentsStatus } from 'types/appointments';
import { getUserId } from 'utils/storage';

export const useRateAppointment = (): void => {
  const patientId = getUserId();
  const { data: nextAppointments } = useFetchNextAppointments(patientId);
  const { showDialog } = useDialogContext();
  const lastProcessedCountRef = useRef(0);

  const appointments = nextAppointments?.filter(
    appointment => appointment?.sessionDetails?.type === AppointmentsStatus.FINISHED_SESSION
  );

  useEffect(() => {
    const currentCount = appointments?.length ?? 0;
    const firstAppointment = appointments?.[0];

    if (currentCount > 0 && currentCount !== lastProcessedCountRef.current && firstAppointment) {
      lastProcessedCountRef.current = currentCount;
      showDialog({
        component: <RateAppointment appointment={firstAppointment} canClose={false} />,
      });
    }
  }, [appointments, showDialog]);
};
